export default {
  setpointEnter: 'Wprowadź punkt nastawy',
  durationMinusLimit: 'Czas trwania – limit',
  realDuration: 'Rzeczywisty czas trwania',
  durationPlusLimit: 'Czas trwania + limit',
  totalTime: 'Całkowity czas w paśmie',
};
